import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { EDMUNDS_LOGO_NO_TEXT } from 'client/images/inline-svgs/edmunds-logo';

const DEFAULT_RATING_SCALE = 5;

export function OverallRating({
  rating,
  ratingScale,
  showStars,
  reviewCount,
  notAvailableCopy,
  ratingClassName,
  ratingScaleClassName,
  ratingStarClassName,
  showLogoDesign,
  logoFillColor,
}) {
  if (!rating) {
    return <div className={ratingScaleClassName}>{notAvailableCopy}</div>;
  }

  const showRatingStars = showStars && ratingScale === DEFAULT_RATING_SCALE;

  const textRatingContainer = (
    <div className={classnames('d-inline-block me-0_75', ratingScaleClassName)}>
      {rating} / {ratingScale} {showRatingStars && <span className="visually-hidden">stars</span>}
    </div>
  );
  const logoRatingContainer = (
    <div className="d-flex align-items-center mt-0_5">
      {EDMUNDS_LOGO_NO_TEXT({ width: 30, fillColor: logoFillColor })}
      <div className="ms-0_75">
        <span className={classnames('size-30 fw-bold', ratingClassName)}>{rating}</span>
        <span className="size-16"> /{ratingScale}</span>
        {showRatingStars && <span className="visually-hidden">stars</span>}
      </div>
    </div>
  );

  return (
    <Fragment>
      {showLogoDesign ? logoRatingContainer : textRatingContainer}
      {showRatingStars && (
        <RatingStars
          rating={rating}
          hideForScreenReader /* notice we are using hideForScreenReader because we have added ' stars' to the div above */
          className={classnames('text-primary-darker d-inline-block', ratingStarClassName)}
        />
      )}
      {reviewCount > 0 && <span className="ps-0_5">({reviewCount})</span>}
    </Fragment>
  );
}

OverallRating.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  reviewCount: PropTypes.number,
  showStars: PropTypes.bool,
  ratingScale: PropTypes.number,
  ratingScaleClassName: PropTypes.string,
  notAvailableCopy: PropTypes.string,
  ratingStarClassName: PropTypes.string,
  showLogoDesign: PropTypes.bool,
  logoFillColor: PropTypes.string,
  ratingClassName: PropTypes.string,
};

OverallRating.defaultProps = {
  rating: 0,
  reviewCount: 0,
  showStars: true,
  ratingScale: DEFAULT_RATING_SCALE,
  ratingScaleClassName: null,
  notAvailableCopy: 'Not Available',
  ratingStarClassName: null,
  showLogoDesign: false,
  logoFillColor: '#0069bf',
  ratingClassName: 'text-primary-darker',
};
